
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

interface PricePerSqMeterEvolutionData {
  months: Array<{
    month: string;
    scrape_date: string;
    avg_price_per_sqm: number;
    total_properties: number;
    properties_with_area_util: number;
    properties_with_area_total: number;
  }>;
  summary: {
    period_start: string;
    period_end: string;
    total_months: number;
    finalidade: string;
  };
}

export const usePricePerSqMeterEvolution = (finalidade: 'venda' | 'aluguel' = 'venda') => {
  return useQuery({
    queryKey: ['price-per-sqm-evolution', finalidade],
    queryFn: async (): Promise<PricePerSqMeterEvolutionData> => {
      console.log(`[usePricePerSqMeterEvolution] Fetching data for: ${finalidade}`);
      
      const { data, error } = await supabase.rpc('get_price_per_sqm_evolution', {
        p_finalidade: finalidade
      });

      if (error) {
        console.error('[usePricePerSqMeterEvolution] Error:', error);
        throw new Error(`Erro ao buscar evolução de preço por m²: ${error.message}`);
      }

      console.log('[usePricePerSqMeterEvolution] Data received:', data);
      
      return data as unknown as PricePerSqMeterEvolutionData;
    },
    staleTime: 5 * 60 * 1000, // 5 minutos
    gcTime: 10 * 60 * 1000, // 10 minutos
    retry: 2,
  });
};
